<template>
  <ion-app>
    <ion-router-outlet/>
  </ion-app>
</template>

<script setup>
import { ref, watch } from 'vue';
import {IonApp, IonRouterOutlet, useIonRouter} from '@ionic/vue';
import {store} from './store';
import {api} from './api';
import { supabase } from './supabase';

// Inject the authenticated Supabase client and credentials into the legacy API instance
api.setSupabaseClient(
  supabase, 
  process.env.VUE_APP_SUPABASE_URL, 
  process.env.VUE_APP_SUPABASE_ANON_KEY
);

import {session, is_weixin} from '@/utils';

const router = useIonRouter();
const isSessionChecked = ref(false);

store.user = api.user() ?? {};
console.log('store.user:', store.user);

// Initialize Supabase session synchronously if possible, or wait for the event
supabase.auth.getSession().then(({ data: { session: currentSession } }) => {
  if (currentSession) {
    session.value = currentSession;
    store.user = currentSession.user;
  }
  isSessionChecked.value = true;
});

if (window._wcprms?.code) {
    console.log('微信小程序环境', window._wcprms?.code);
    is_weixin.value = true;
    //always show chat page first in wechat
    router.replace('/tabs/chat');
} else {
    // Keep existing api listener just in case
    console.log('api onAuthStateChange:');
    api.onAuthStateChange((event, _session) => {
      console.log('api auth event:', event, _session);
      // Legacy listener only handles initial sync or legacy login.
      // Navigation is now handled by the Supabase listener below.
      if (event === 'login' && !session.value) {
         session.value = _session;
         store.user = _session?.user ?? {};
      }
    });

    // Supabase Auth State Listener
    supabase.auth.onAuthStateChange(async (event, _session) => {
      console.log('Supabase auth event:', event, _session?.user?.email);
      
      // Mark as checked on first auth state change too
      isSessionChecked.value = true;

      if (event === 'SIGNED_OUT') {
         // 1. Trigger legacy signout (non-blocking)
         api.signOut().catch(e => console.warn("Background legacy signOut failed", e));
         
         // 2. Explicitly clear all auth tokens and session data 
         const keysToClear = ['session', 'openid', 'supabase.auth.token', 'sb-msqwpooqyqkqkudgzozf-auth-token'];
         keysToClear.forEach(key => {
           localStorage.removeItem(key);
           sessionStorage.removeItem(key);
         });
         
         // 3. Reset reactive state
         session.value = null;
         store.user = {};
         
         // 4. Force hard reset to ensure no cached state remains
         setTimeout(() => {
           window.location.href = window.location.origin + '/?logout=' + Date.now();
         }, 100);
         return;
      }
      
      if (_session?.user) {
        // Normalize user object for legacy code
        const user = {
          ..._session.user,
          id: _session.user.id,
          uid: _session.user.id
        };
        session.value = { ..._session, user };
        store.user = user;

        // Bridge to legacy API if not already signed in there
        if (!api.user()) {
          console.log("Bridging Supabase session to legacy API...");
          try {
            await api.signInWithCode(user.id);
          } catch (err) {
            console.error("Failed to bridge session to legacy API", err);
          }
        }
      } else {
        session.value = null;
        store.user = {};
        
        // If no session and on a protected route, redirect to login
        // ONLY if the initial session check is complete
        const path = window.location.pathname;
        if (isSessionChecked.value && (path.startsWith('/tabs/') || path === '/profile' || path === '/setProfile')) {
          console.log('No session on protected route, redirecting to login...');
          router.replace('/');
        }
      }
      
      if (event === 'SIGNED_IN' || event === 'TOKEN_REFRESHED') {
        router.replace('/tabs/chat');
      }
    });

    // Handle initial state if getSession was null or slow
    // Wait for the session check to finish before redirecting
    watch(isSessionChecked, (checked) => {
      if (checked && !session.value) {
        const path = window.location.pathname;
        if ((path.startsWith('/tabs/') || path === '/profile') && !window._wcprms?.code) {
           console.log('Initial check complete, no session found. Redirecting to login...');
           router.replace('/');
        }
      }
    });
}

</script>
